import React from 'react';

import { ProfilesAnnouncementBackgroundWrapper } from '@/scenarios/profiles/components/ProfilesAnnouncementBackgroundWrapper/ProfilesAnnouncementBackgroundWrapper';
import { MovieAnnouncements } from '@/scenarios/profiles/components/MovieAnnouncements/MovieAnnouncements';

import { useMovieAnnouncementsNotification } from '../../hooks/useMoveAnnouncementsNotification';

import styles from './ProfilesAnnouncementBackgroundYango.module.css';

export const ProfilesAnnouncementBackgroundYango = () => {
    const { onView, notification } = useMovieAnnouncementsNotification();
    const movies = notification?.items;

    return (
        <ProfilesAnnouncementBackgroundWrapper gradient={Boolean(movies?.length)}>
            {movies?.length ? (
                <MovieAnnouncements items={movies} onMount={onView} />
            ) : (
                <div className={styles.backgroundFallback} />
            )}
        </ProfilesAnnouncementBackgroundWrapper>
    );
};
